import Swal from 'sweetalert2'

export const alertSuccess = (title, text) => {    
    Swal.fire({  
        title: title,  
        text: text,
        icon: 'success'
      }); 
}